import { sendMessage } from '../../config/utils/message'
import { CORE_API_AKADEMIK } from '../key/api'

export async function getSemester(nim) {
    try {
        const response = await CORE_API_AKADEMIK.get('semester/dropdown?nim=' + nim)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}